import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { publicUrgencyApi } from '../api/publicUrgencyApi';

export function usePublicUrgencyPage(token: string | null | undefined, enabled = false) {
  return useQuery({
    queryKey: keys.publicUrgencyPage(token ?? ''),
    queryFn: ({ signal }) => publicUrgencyApi.getPage(token!, { signal }),
    enabled: !!token && enabled,
    staleTime: 60_000,
  });
}
